/* eslint-disable react/prop-types */
import React from 'react';
import { Formik } from 'formik';
import {
  DatePickerField,
  DerivedField,
  SignatureField,
  TextField,
  TitleField,
  UploadField,
} from 'components/Molecules/FormFields/index';
import { Form, Row, Col, Button } from 'antd';
import { PlusCircleFilled } from '@ant-design/icons';
import cn from 'classnames';
import FormObserver from 'components/New/FormStepper/FormObserver';
import { FileHelpers } from 'helpers/file/index';
import T from 'i18n-react';
import classes from './SignOff.module.scss';

const { convertFileToBase64 } = FileHelpers;

const SignOffForm = (props, ref) => {
  const { initialValues, onSubmit } = props;
  const formRef = React.useRef(null);
  const signatureRef = React.useRef(null);

  const updateSignatureFromSignatureFiles = async (signatureFiles) => {
    if (signatureFiles && signatureFiles.length > 0) {
      const uploadEsignature = signatureFiles[0];
      if (uploadEsignature && uploadEsignature.originFileObj) {
        const { originFileObj } = uploadEsignature;
        const dataUrl = await convertFileToBase64(originFileObj);
        formRef.current.setFieldValue('signature', dataUrl);
      } else {
        // Fetch and convert to base64
        const dataUrl = await FileHelpers.readAndConvertFileFromRemoteUrl(
          uploadEsignature.downloadUrl
        );
        formRef.current.setFieldValue('signature', dataUrl);
      }
    }
  };

  const handleValuesChanged = async (changed) => {
    const fieldChanged = Object.keys(changed)[0];
    // const { signatureDate } = values;
    if (fieldChanged === 'signatureFiles') {
      const { signatureFiles } = changed;
      if (signatureFiles.length > 0) {
        const uploadEsignature = signatureFiles[0];
        if (uploadEsignature && uploadEsignature.originFileObj) {
          const { originFileObj } = uploadEsignature;
          const dataUrl = await convertFileToBase64(originFileObj);
          formRef.current.setFieldValue('signature', dataUrl);
        } else {
          // Fetch and convert to base64
          const dataUrl = await FileHelpers.readAndConvertFileFromRemoteUrl(
            uploadEsignature.downloadUrl
          );
          formRef.current.setFieldValue('signature', dataUrl);
        }
      }
    }
    // if (fieldChanged === 'signature') {
    //   if (changed.signature && !signatureDate) {
    //     formRef.current.setFieldValue('signatureDate', moment());
    //   }
    // }
  };

  React.useImperativeHandle(ref, () => ({
    submit: () => formRef.current.submitForm(),
  }));

  React.useEffect(() => {
    const { signatureFiles } = initialValues;
    updateSignatureFromSignatureFiles(signatureFiles);
  }, [initialValues]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        signatureDate: null,
        issueDate: undefined,
        signatureFiles: [],
        signature: null,
        ...initialValues,
      }}
      onSubmit={onSubmit}>
      {(fomrikProps) => {
        formRef.current = fomrikProps;
        const { values } = fomrikProps;
        const { signatureFiles } = values;

        return (
          <Form className={classes.signOff} layout="vertical">
            <FormObserver onChange={handleValuesChanged} />
            <div>
              <TitleField
                level={5}
                layoutClasses={cn(classes.titleField, {
                  [classes.mb16]: true,
                })}>
                Add Detail and Signature:
              </TitleField>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <TextField
                    placeholder={T.translate('placeholder.fillHere')}
                    name="name"
                    label="Name"
                  />
                </Col>
                <Col span={12}>
                  <TextField
                    placeholder={T.translate('placeholder.fillHere')}
                    name="title"
                    label="Title"
                  />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <DatePickerField
                    name="issueDate"
                    style={{ width: '100%' }}
                    label="Date of Issue"
                  />
                </Col>
                <Col span={12}>
                  <TextField
                    placeholder={T.translate('placeholder.fillHere')}
                    name="issuePlace"
                    label="Place of Issue"
                  />
                </Col>
              </Row>
              <TitleField
                level={5}
                layoutClasses={cn(classes.titleField, {
                  [classes.mb16]: true,
                })}>
                <span className={classes.signature}>
                  Signature Area:
                  <Button
                    hidden={Array.isArray(signatureFiles) && signatureFiles.length > 0}
                    type="link"
                    onClick={() => {
                      signatureRef.current.clear();
                    }}>
                    Clear
                  </Button>
                </span>
              </TitleField>
              <SignatureField
                name="signature"
                layoutClasses={cn({
                  [classes.mb16]: true,
                })}
                disabled={Array.isArray(signatureFiles) && signatureFiles.length > 0}
                ref={signatureRef}
                width={648}
              />
              <div
                className={cn(classes.uploadContainer, {
                  [classes.readonly]: Array.isArray(signatureFiles) && signatureFiles.length > 0,
                })}>
                <span className={classes.subtitle}>Uploaded E-signature</span>
                <UploadField
                  readonly={Array.isArray(signatureFiles) && signatureFiles.length > 0}
                  layoutClasses={cn({
                    [classes.mb0]: true,
                  })}
                  name="signatureFiles"
                  uploadButtonProps={{
                    type: 'link',
                    icon: <PlusCircleFilled />,
                    style: { paddingLeft: 0 },
                  }}
                />
              </div>
              <DerivedField
                layoutClasses={cn(classes.horizontalField, {
                  [classes.mb0]: true,
                })}
                format={(value) => {
                  if (value) return value.format('DD/MM/YYYY');
                  return '/';
                }}
                name="signatureDate"
                label="Signature Date:"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default React.forwardRef(SignOffForm);
